import { Box } from '@mui/material';
import type { ProcessorOpsHealthStatus } from '@/types/dtos/ops/ops-platform.dto';

const HEALTH_COLOR: Record<ProcessorOpsHealthStatus, string> = {
  healthy: 'success.main',
  degraded: 'warning.main',
  critical: 'error.main',
};

type OpsStatusDotProps = {
  status: ProcessorOpsHealthStatus | null | undefined;
  size?: number;
};

export default function OpsStatusDot({ status, size = 8 }: OpsStatusDotProps) {
  const color = status ? HEALTH_COLOR[status] : 'action.disabled';
  return (
    <Box
      component="span"
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        bgcolor: color,
        flexShrink: 0,
        display: 'inline-block',
      }}
    />
  );
}
